module.exports = __webpack_public_path__ + "assets/311761260d0d016ac6ed25aee8fb6200.svg";